import { User } from '../models/User';
import { UserDto } from '../interfaces/dto/user.dto';
import { Injectable } from '@angular/core';
import { GroupAdapter } from './group.adapter';
import { UserBasicDto } from '../users/dto/user-basic.dto';

@Injectable({
  providedIn: 'root'
})
export class UserAdapter {
  constructor(private groupAdapter: GroupAdapter) {
  }

  runBasic(dto: UserBasicDto): User {
    return {
      ...dto,
      fullName: dto.firstName + (dto.lastName ? ' ' + dto.lastName : ''),
      tourComplete: false,
      groups: []
    };
  }

  run(dto: UserDto): User {
    return {
      ...dto,
      fullName: dto.firstName + (dto.lastName ? ' ' + dto.lastName : ''),
      tourComplete: !!dto.tourComplete,
      groups: dto.groups ? dto.groups.map((group) => this.groupAdapter.run(group)) : []
    };
  }
}
